export class Histogram {
    R: Float32Array<ArrayBuffer>;
    G: Float32Array<ArrayBuffer>;
    B: Float32Array<ArrayBuffer>;
    RGB: Float32Array<ArrayBuffer>;

    constructor(pixels: (string | number)[], width: number, height: number) {
        var self = this;
        self.R = new Float32Array(256);
        self.G = new Float32Array(256);
        self.B = new Float32Array(256);
        self.RGB = new Float32Array(256);

        var maxR = 0, maxG = 0, maxB = 0, max = 0;
        for (var i = 0; i < width * height * 4; i += 4) {
            self.R[pixels[i]] += 1;
            maxR = Math.max(maxR, self.R[pixels[i]]);
            self.G[pixels[i + 1]] += 1;
            maxG = Math.max(maxG, self.G[pixels[i + 1]]);
            self.B[pixels[i + 2]] += 1;
            maxB = Math.max(maxB, self.B[pixels[i + 2]]);

            self.RGB[pixels[i]] += 1;
            self.RGB[pixels[i + 1]] += 1;
            self.RGB[pixels[i + 2]] += 1;
            max = Math.max(max, self.RGB[pixels[i]], self.RGB[pixels[i + 1]], self.RGB[pixels[i + 2]]);
        }

        for (var i = 0; i < 256; ++i) {
            self.R[i] /= maxR;
            self.G[i] /= maxG;
            self.B[i] /= maxB;
            self.RGB[i] /= max;
        }
    }

}